import type { ReactNode } from 'react'
import type { WorkspaceTab } from '@/hooks/useWorkspaceTabs'

interface Props {
  id: WorkspaceTab
  active: WorkspaceTab
  visited: Set<WorkspaceTab>
  children: ReactNode
  /** If true, unmount when leaving (default: keep mounted after first visit) */
  ephemeral?: boolean
}

/**
 * Keep-alive tab panel — mounts on first visit, then hides with [hidden]
 * so state (filters, form drafts) survives tab switches without remount cost.
 */
export function TabPanel({ id, active, visited, children, ephemeral }: Props) {
  const isActive = active === id
  if (!visited.has(id) && !isActive) return null
  if (ephemeral && !isActive) return null

  return (
    <div
      id={`panel-${id}`}
      role="tabpanel"
      aria-labelledby={`tab-${id}`}
      hidden={!isActive}
      className={`ws-panel${isActive ? ' active' : ''}`}
    >
      {children}
    </div>
  )
}
